import { LineV3toLine3 as i } from "../index2.js";
import { doLinesOverlap as f } from "./index6.js";
import { getOverlapLine as s } from "./index12.js";
function l(e, n) {
  e = e.map(i), n = n.map(i);
  const r = [];
  for (const p of e) {
    const a = n.filter((o) => f(p, o));
    for (const o of a) {
      const t = s(o, p);
      i(t).distanceSq() > 0 && r.push(t);
    }
  }
  return r;
}
export {
  l as getOverlappingLinesBetweenSets
};
//# sourceMappingURL=index13.js.map
